import List from '../../containers/OrderRequirements/List';
import Edit from '../../containers/OrderRequirements/Edit';
import Create from '../../containers/OrderRequirements/Create';
import Show from '../../containers/OrderRequirements/Show';

export default { List, Edit, Create, Show };
